import { afterRenderEffect, computed, effect, ElementRef, inject, input, signal, untracked, viewChild, } from '@angular/core';
import { AgentSessionStateService } from 'AgentApp/ts/services/agent-session-state.service';
import { AgentSidePanelStateService } from 'AgentApp/ts/services/agent-side-panel-state.service';
import { AgentTransportService } from 'AgentApp/ts/services/agent-transport.service';
import { AgentUserPreferencesService } from 'AgentApp/ts/services/agent-user-preferences.service';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { AgentLoaderComponent } from 'AgentApp/ts/features/agent/components/agent-loader/agent-loader.component';
import { AgentResponseMessageComponent } from 'AgentApp/ts/features/agent/components/agent-response-message/agent-response-message.component';
import { AgentStepsComponent } from 'AgentApp/ts/features/agent/components/agent-steps/agent-steps.component';
import { AgentTasksComponent } from 'AgentApp/ts/features/agent/components/agent-tasks/agent-tasks.component';
import { AgentToolPermissionBoxComponent } from 'AgentApp/ts/features/agent/components/agent-tool-permission-box/agent-tool-permission-box.component';
import { AgentUserInputComponent } from 'AgentApp/ts/features/agent/components/agent-user-input/agent-user-input.component';
import { AgentUserMessageComponent } from 'AgentApp/ts/features/agent/components/agent-user-message/agent-user-message.component';
import { PageContextClientTool } from 'AgentApp/ts/client-tools/page-context.client-tool';
import * as i0 from "@angular/core";
const _c0 = ["scrollContainer"];
const _c1 = () => [];
function AgentSidePanelComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 6)(2, "div", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtext(5, "How can I help you today?");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtext(7, "Not sure? ");
    i0.ɵɵelementStart(8, "div", 10);
    i0.ɵɵtext(9, "Ask me what I can do.");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Hello, ", ctx_r1.user.firstName, ".");
} }
function AgentSidePanelComponent_Conditional_5_For_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-user-message", 15);
} if (rf & 2) {
    const message_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("messageText", message_r3.text)("files", message_r3.files);
} }
function AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-steps", 18);
    i0.ɵɵlistener("toggled", function AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Conditional_0_Template_ycn_agent_steps_toggled_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onStepsToggled($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("steps", message_r3.steps)("expanded", ctx_r1.stepsExpanded());
} }
function AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-response-message", 17);
} if (rf & 2) {
    const message_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("messageText", message_r3.text)("displayActions", message_r3.displayActions ?? i0.ɵɵpureFunction0(3, _c1))("displayAsCard", true);
} }
function AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Conditional_0_Template, 1, 2, "ycn-agent-steps", 16);
    i0.ɵɵconditionalCreate(1, AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Conditional_1_Template, 1, 4, "ycn-agent-response-message", 17);
} if (rf & 2) {
    const message_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional((message_r3.steps == null ? null : message_r3.steps.length) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(message_r3.text ? 1 : -1);
} }
function AgentSidePanelComponent_Conditional_5_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentSidePanelComponent_Conditional_5_For_1_Conditional_0_Template, 1, 2, "ycn-agent-user-message", 15)(1, AgentSidePanelComponent_Conditional_5_For_1_Conditional_1_Template, 2, 2);
} if (rf & 2) {
    const message_r3 = ctx.$implicit;
    i0.ɵɵconditional(message_r3.role === "user" ? 0 : message_r3.role === "assistant" ? 1 : -1);
} }
function AgentSidePanelComponent_Conditional_5_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-steps", 19);
    i0.ɵɵlistener("toggled", function AgentSidePanelComponent_Conditional_5_Conditional_2_Template_ycn_agent_steps_toggled_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onStepsToggled($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("steps", ctx_r1.currentTaskSteps())("streaming", true)("expanded", ctx_r1.stepsExpanded());
} }
function AgentSidePanelComponent_Conditional_5_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-tool-permission-box", 20);
    i0.ɵɵlistener("confirm", function AgentSidePanelComponent_Conditional_5_Conditional_3_Template_ycn_agent_tool_permission_box_confirm_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onToolPermissionConfirm($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("toolCall", ctx);
} }
function AgentSidePanelComponent_Conditional_5_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-loader", 13);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("currentLoadingText", ctx_r1.currentLoadingText());
} }
function AgentSidePanelComponent_Conditional_5_For_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "ycn-agent-user-message", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const queued_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("messageText", queued_r7.text)("files", queued_r7.files);
} }
function AgentSidePanelComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, AgentSidePanelComponent_Conditional_5_For_1_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵconditionalCreate(2, AgentSidePanelComponent_Conditional_5_Conditional_2_Template, 1, 3, "ycn-agent-steps", 11);
    i0.ɵɵconditionalCreate(3, AgentSidePanelComponent_Conditional_5_Conditional_3_Template, 1, 1, "ycn-agent-tool-permission-box", 12)(4, AgentSidePanelComponent_Conditional_5_Conditional_4_Template, 1, 1, "ycn-agent-loader", 13);
    i0.ɵɵrepeaterCreate(5, AgentSidePanelComponent_Conditional_5_For_6_Template, 2, 2, "div", 14, i0.ɵɵrepeaterTrackByIndex);
} if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r1.currentMessages());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(((tmp_3_0 = ctx_r1.currentTaskSteps()) == null ? null : tmp_3_0.length) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_4_0 = ctx_r1.currentToolCallToConfirm()) ? 3 : ctx_r1.isLoading() ? 4 : -1, tmp_4_0);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.queuedMessagesForDisplay());
} }
const MAX_AUDIO_CANVAS_WIDTH_ATTACHED = 142;
const MAX_AUDIO_CANVAS_WIDTH_DETACHED = 431;
export class AgentSidePanelComponent {
    constructor() {
        this._connection = inject(AgentTransportService);
        this._panelState = inject(AgentSidePanelStateService);
        this._sessionState = inject(AgentSessionStateService);
        this._preferencesService = inject(AgentUserPreferencesService);
        this._pageContextService = inject(PageContextClientTool);
        this.isDetached = input(false, ...(ngDevMode ? [{ debugName: "isDetached" }] : []));
        this.screen = this._panelState.screen;
        this.pendingNewSessionMessage = this._sessionState.pendingNewSessionMessage;
        this.chatState = computed(() => this._sessionState.getChatState(this._panelState.currentSessionId()), ...(ngDevMode ? [{ debugName: "chatState" }] : []));
        this.currentMessages = computed(() => {
            const pending = this.pendingNewSessionMessage();
            if (pending) {
                return [{ role: 'user', text: pending.text, files: pending.files }];
            }
            return this.chatState().messages;
        }, ...(ngDevMode ? [{ debugName: "currentMessages" }] : []));
        this.isLoading = computed(() => !!this.pendingNewSessionMessage() || this.chatState().isLoading, ...(ngDevMode ? [{ debugName: "isLoading" }] : []));
        this.currentLoadingText = computed(() => this.chatState().currentLoadingText, ...(ngDevMode ? [{ debugName: "currentLoadingText" }] : []));
        this.currentTaskSteps = computed(() => this.chatState().agentSteps, ...(ngDevMode ? [{ debugName: "currentTaskSteps" }] : []));
        this.stepsExpanded = signal(true, ...(ngDevMode ? [{ debugName: "stepsExpanded" }] : []));
        this.currentToolCallToConfirm = computed(() => this.chatState().toolCallsToConfirm[0] ?? null, ...(ngDevMode ? [{ debugName: "currentToolCallToConfirm" }] : []));
        this.queuedMessagesForDisplay = computed(() => this.chatState().queuedMessages.map((message) => ({
            text: message.text,
            files: message.files.map((file) => ({
                attachment_url: file.name,
                attachment_mime_type: file.type,
                external_file_id: '',
            })),
        })), ...(ngDevMode ? [{ debugName: "queuedMessagesForDisplay" }] : []));
        this._isAgentBusy = computed(() => {
            const state = this.chatState();
            return state.isStreaming || state.toolCallsToConfirm.length > 0;
        }, ...(ngDevMode ? [{ debugName: "_isAgentBusy" }] : []));
        this.visibleTasks = this._sessionState.visibleTasks;
        this.completedTasks = this._sessionState.completedTasks;
        this.inProgressTasks = this._sessionState.inProgressTasks;
        this.cancelledTasks = this._sessionState.cancelledTasks;
        this.taskCompletionPercentage = this._sessionState.taskCompletionPercentage;
        this.hasInProgressTasks = this._sessionState.hasInProgressTasks;
        this.scrollContainer = viewChild('scrollContainer', ...(ngDevMode ? [{ debugName: "scrollContainer" }] : []));
        this.isWelcomeScreen = computed(() => {
            const sessionId = this._panelState.currentSessionId();
            const pendingNewSessionMessage = this.pendingNewSessionMessage();
            return sessionId === null && !pendingNewSessionMessage;
        }, ...(ngDevMode ? [{ debugName: "isWelcomeScreen" }] : []));
        this.isChatScreen = computed(() => {
            const sessionId = this._panelState.currentSessionId();
            const pendingNewSessionMessage = this.pendingNewSessionMessage();
            return sessionId !== null || !!pendingNewSessionMessage;
        }, ...(ngDevMode ? [{ debugName: "isChatScreen" }] : []));
        this.user = window.USER;
        this.maxAudioCanvasWidth = computed(() => {
            const isDetached = this.isDetached();
            if (isDetached) {
                return MAX_AUDIO_CANVAS_WIDTH_DETACHED;
            }
            return MAX_AUDIO_CANVAS_WIDTH_ATTACHED;
        }, ...(ngDevMode ? [{ debugName: "maxAudioCanvasWidth" }] : []));
        afterRenderEffect(() => {
            this.isLoading();
            this.currentMessages();
            this.currentTaskSteps();
            this.currentToolCallToConfirm();
            this.queuedMessagesForDisplay();
            const el = this.scrollContainer()?.nativeElement;
            if (el) {
                el.scrollTop = el.scrollHeight;
            }
        });
        effect(async () => {
            const sessionId = this._panelState.currentSessionId();
            const isAgentBusy = this._isAgentBusy();
            const { queuedMessages } = this.chatState();
            if (!sessionId || isAgentBusy) {
                return;
            }
            if (!queuedMessages.length) {
                return;
            }
            await untracked(async () => {
                const queued = this._sessionState.dequeueAllMessages(sessionId);
                if (!queued.length) {
                    return;
                }
                const combined = {
                    text: queued
                        .map((message) => message.text)
                        .filter(Boolean)
                        .join('\n\n'),
                    files: queued.flatMap((message) => message.files),
                };
                await this.sendMessage(combined);
            });
        });
    }
    ngOnInit() {
        this._preferencesService.get().subscribe(async (prefs) => {
            this.stepsExpanded.set(prefs.agent_side_panel_steps_expanded);
            const savedSessionId = prefs.last_visited_side_menu_session_id;
            if (savedSessionId != null) {
                this._panelState.currentSessionId.set(savedSessionId);
                try {
                    await this._connection.loadAndResumeSession(savedSessionId, window.USER.userId);
                }
                catch {
                    this._panelState.currentSessionId.set(null);
                    this._preferencesService.save({ last_visited_side_menu_session_id: null }).subscribe();
                }
            }
        });
    }
    openNewChat() {
        this._panelState.currentSessionId.set(null);
        this._preferencesService.save({ last_visited_side_menu_session_id: null }).subscribe();
    }
    onStepsToggled(expanded) {
        this._preferencesService.save({ agent_side_panel_steps_expanded: expanded }).subscribe();
    }
    async sendMessage(message) {
        const currentSessionId = this._panelState.currentSessionId();
        if (currentSessionId && this._isAgentBusy()) {
            this._sessionState.enqueueMessage(currentSessionId, message);
            return;
        }
        const sliceKey = await this._pageContextService.getCurrentSliceKey();
        const clientContext = { source: 'side_panel', app_state_slice_key: sliceKey };
        window.pendoTrack('Submitted Input to Agent', {
            message: message.text,
            fileCount: message.files.length,
            source: clientContext.source,
        });
        if (currentSessionId) {
            await this._connection.sendUserMessage(currentSessionId, message.text, message.files, clientContext);
        }
        else {
            const session = await this._connection.createSession(message.text, message.files);
            this._panelState.currentSessionId.set(session.id);
            this._preferencesService.save({ last_visited_side_menu_session_id: session.id }).subscribe();
            const recentSession = {
                id: session.id,
                name: session.name,
                pinned: false,
                provider: 'anthropic',
            };
            this._sessionState.addSessionToRecent(recentSession);
            this._connection.generateAndApplySessionDisplay(recentSession, message.text);
            await this._connection.sendUserMessage(session.id, message.text, message.files, clientContext);
        }
    }
    onDeleteTask(task) {
        this._sessionState.deleteTask(task);
    }
    onHideTask(task) {
        this._sessionState.hideTask(task);
    }
    onTaskSelected(task) {
        this._sessionState.selectTask(task);
    }
    onToolPermissionConfirm(event) {
        const toolCall = this.currentToolCallToConfirm();
        const sessionId = this._panelState.currentSessionId();
        if (toolCall && sessionId) {
            this._connection.confirmToolCall(sessionId, window.USER.userId, event.authorize, event.alwaysApply, toolCall);
        }
    }
}
AgentSidePanelComponent.ɵfac = function AgentSidePanelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSidePanelComponent)(); };
AgentSidePanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSidePanelComponent, selectors: [["ycn-agent-side-panel"]], viewQuery: function AgentSidePanelComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.scrollContainer, _c0, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, inputs: { isDetached: [1, "isDetached"] }, decls: 7, vars: 10, consts: [["scrollContainer", ""], [3, "deleteTask", "hideTask", "taskSelected", "visibleTasks", "completedTasks", "inProgressTasks", "cancelledTasks", "completionPercentage", "hasInProgressTasks"], [1, "side-panel-content", "bg-side-panel-ai", "flex-auto", "min-height-0", "d-flex", "flex-column"], [1, "overflow-auto", "z-1", "pt-4", "pl-20", "pr-20", "height-full"], [1, "height-full", "min-height-200", "d-flex", "flex-column", "justify-content-center", "text-center"], [1, "flex-none", "z-1", "pt-20", "pl-20", "pr-20", "pb-4", 3, "openNewChat", "sendMessage", "maxAudioCanvasWidth", "showNewChatButton", "showPromptTools"], [1, "mb-6"], [1, "side-panel-empty-state", "mb-1"], [1, "side-panel-empty-subtitle"], [1, "side-panel-empty-text", "pt-2"], [1, "text-normal"], [3, "steps", "streaming", "expanded"], [3, "toolCall"], [3, "currentLoadingText"], [2, "opacity", "0.5"], [3, "messageText", "files"], [3, "steps", "expanded"], [3, "messageText", "displayActions", "displayAsCard"], [3, "toggled", "steps", "expanded"], [3, "toggled", "steps", "streaming", "expanded"], [3, "confirm", "toolCall"]], template: function AgentSidePanelComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-agent-tasks", 1);
        i0.ɵɵlistener("deleteTask", function AgentSidePanelComponent_Template_ycn_agent_tasks_deleteTask_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onDeleteTask($event)); })("hideTask", function AgentSidePanelComponent_Template_ycn_agent_tasks_hideTask_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onHideTask($event)); })("taskSelected", function AgentSidePanelComponent_Template_ycn_agent_tasks_taskSelected_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onTaskSelected($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 2)(2, "div", 3, 0);
        i0.ɵɵconditionalCreate(4, AgentSidePanelComponent_Conditional_4_Template, 10, 1, "div", 4)(5, AgentSidePanelComponent_Conditional_5_Template, 7, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ycn-agent-user-input", 5);
        i0.ɵɵlistener("openNewChat", function AgentSidePanelComponent_Template_ycn_agent_user_input_openNewChat_6_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openNewChat()); })("sendMessage", function AgentSidePanelComponent_Template_ycn_agent_user_input_sendMessage_6_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.sendMessage($event)); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("visibleTasks", ctx.visibleTasks())("completedTasks", ctx.completedTasks())("inProgressTasks", ctx.inProgressTasks())("cancelledTasks", ctx.cancelledTasks())("completionPercentage", ctx.taskCompletionPercentage())("hasInProgressTasks", ctx.hasInProgressTasks());
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.isWelcomeScreen() ? 4 : ctx.isChatScreen() ? 5 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("maxAudioCanvasWidth", ctx.maxAudioCanvasWidth())("showNewChatButton", true)("showPromptTools", false);
    } }, dependencies: [IconModule,
        AgentUserInputComponent,
        AgentLoaderComponent,
        AgentStepsComponent,
        AgentUserMessageComponent,
        AgentResponseMessageComponent,
        AgentTasksComponent,
        AgentToolPermissionBoxComponent], styles: ["[_nghost-%COMP%] {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }"], changeDetection: 0 });
